var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 10 6",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.187761 0.210793C0.0675962 0.338409 -2.39893e-07 0.511883 -2.3202e-07 0.69201C-2.24117e-07 0.8728 0.067593 1.04627 0.187761 1.17389L4.54123 5.80059C4.6614 5.92821 4.82412 6 4.99435 6C5.16458 6 5.3273 5.92821 5.44746 5.80059L9.80094 1.17389C9.92611 1.0476 9.99809 0.872136 9.99996 0.688674C10.0018 0.50523 9.93425 0.328421 9.81158 0.198813C9.68953 0.069202 9.52305 -0.00258297 9.35032 7.15937e-05C9.17759 0.00272615 9.01298 0.0791665 8.89407 0.212102L4.99433 4.35761L1.0946 0.212102C0.974436 0.0844855 0.811718 0.0120334 0.641485 0.0120334C0.471252 0.0113692 0.307909 0.0831532 0.187744 0.210775L0.187761 0.210793Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevronDown.8b4803b0.svg";
export { ForwardRef as ReactComponent };